export { VIClickOutsideDirective } from './click-outside/click-outside.directive';
